<template>
  <base-page>
    <titlu-pagina Titlu="Devize de aprobat" :AdaugaVisible="false" />

    <el-table el-table :data="Results">
      <el-table-column prop="Id" label="#" width="80px" />
      <el-table-column prop="DataDeschiderii" label="Data deschiderii">
        <template slot-scope="scope">
          {{ scope.row.DataDeschiderii | DataOraFaraSec }}
        </template>
      </el-table-column>
      <el-table-column prop="DataInchiderii" label="Data inchiderii">
        <template slot-scope="scope">
          {{ scope.row.DataInchiderii | DataOraFaraSec }}
        </template>
      </el-table-column>
      <el-table-column prop="Numar" label="Numar"></el-table-column>
      <el-table-column prop="NumeClient" label="Client"></el-table-column>
      <el-table-column prop="ValoareDeviz" label="Valoare"></el-table-column>
      <el-table-column prop="PresiuneRoti" label="Presiune roti fata"></el-table-column>
      <el-table-column prop="PresiuneRotiSpate" label="Presiune roti spate"></el-table-column>
      <el-table-column prop="Cuplu" label="Cuplu de strangere (fata)" width="200px"></el-table-column>
      <el-table-column label="Cuplu de strangere (spate)" width="210px">
        <template slot-scope="scope">
          <span v-if="scope.row.CupluSpate != null && scope.row.CupluSpate !== ''">
            {{ scope.row.CupluSpate }}
          </span>
          <span v-else>
            {{ scope.row.Cuplu }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="Antifurt" label="Antifurt">
        <template slot-scope="scope">
          {{ scope.row.Antifurt == 0 ? "Nu" : "Da" }}
        </template>
      </el-table-column>
      <el-table-column prop="Penalizat" label="Penalizat">
        <template slot-scope="scope">
          {{ scope.row.Penalizat == 0 ? "Nu" : "Da" }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="right" label="Actiuni" width="200px">
        <template slot-scope="scope">
          <el-tooltip content="Penalizeaza deviz">
            <el-button type="danger" size="mini" icon="el-icon-warning" circle @click="open_penalizare(scope.row)" />
          </el-tooltip>
          <el-tooltip content="Preview">
            <el-button type="primary" size="mini" icon="el-icon-view" circle @click="preview(scope.row.Id)" />
          </el-tooltip>
          <el-tooltip content="Aproba">
            <el-button type="success" size="mini" icon="el-icon-check" circle @click="aprobaTrigger(scope.row.Id)" />
          </el-tooltip>
          <el-tooltip content="Respinge">
            <el-button type="danger" size="mini" icon="el-icon-close" circle @click="respinge(scope.row.Id)" />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @size-change="refresh_info" @current-change="refresh_info" :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page" :total="PaginationInfo.RowCount" layout="pager" /> <br /><br />


    <!-- <titlu-pagina
      Titlu="Devize in lucru"
      :AdaugaVisible="false"
    />
    <el-table el-table :data="DevizeInLucru">
      <el-table-column prop="Id" label="#"></el-table-column>
      <el-table-column prop="DataDeschiderii" label="Data deschiderii"></el-table-column>
      <el-table-column prop="DataInchiderii" label="Data inchiderii"></el-table-column>
      <el-table-column prop="Numar" label="Numar"></el-table-column>
      <el-table-column prop="NumeClient" label="Client"></el-table-column>
      <el-table-column prop="ValoareDeviz" label="Valoare"></el-table-column>
      <el-table-column prop="PresiuneRoti" label="Presiune roti"></el-table-column>
      <el-table-column prop="Cuplu" label="Cuplu de strangere"></el-table-column>
      <el-table-column prop="Antifurt" label="Antifurt">
        <template slot-scope="scope">
          {{ scope.row.Antifurt == 0 ? "Nu" : "Da" }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Actiuni" width="200px">
        <template slot-scope="scope">
          <el-tooltip content="Sterge">
            <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="sterge(scope.row.Id)" />
          </el-tooltip>          
        </template>
      </el-table-column>
    </el-table> -->

    <!-- <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager"
    /> -->

    <el-dialog title="Respinge" :visible.sync="showDialogRespingere" width="80%">
      <el-form label-position="top" :inline="false" label-width="100%" :model='devizSelectat' ref='my-form'
        :rules='rules' @submit.prevent="respinge_deviz">
        <el-row :gutter="15">
          <el-col :span='24'>
            <el-form-item label='Motiv' prop="MotivRespingere">
              <el-input v-model="devizSelectat.MotivRespingere" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialogRespingere = false"> Renunta </el-button>
        <el-button type="danger" @click="respinge_deviz"> Respinge </el-button>
      </span>
    </el-dialog>
    <el-dialog title="Motiv stergere" :visible.sync="showDialogMotivStergere" width="30%">
      <el-input placeholder="" v-model="motivStergere"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialogMotivStergere = false">Cancel</el-button>
        <el-button type="primary" @click="confirmaStergere">Confirm</el-button>
      </span>
    </el-dialog>
    <Previewdeviz ref="preview_deviz" />
    <Devize_de_aprobat_dialog ref="devize_de_aprobat" @aprobaDevizHandler="aproba" />
    <penalizare-dialog ref="dlg_penalizare" @saved="refresh_info()" />

  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import Previewdeviz from '@/components/Preview_deviz';
import Devize_de_aprobat_dialog from "./Devize_de_aprobat_dialog.vue";
import PenalizareDialog from "../../components/PenalizareDialog.vue";
export default {
  name: "masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    Previewdeviz,
    Devize_de_aprobat_dialog,
    'penalizare-dialog': PenalizareDialog
  },
  data() {
    return {
      showDialogRespingere: false,
      showPreviewDeviz: false,
      devizSelectat: { Id: '', MotivRespingere: '' },
      rules: {
        MotivRespingere: [{ required: true, message: "Campul este obligatoriu" }],
      },
      Results: [],
      DevizeInLucru: [],
      idDeSters: '',
      motivStergere: '',
      showDialogMotivStergere: false,
      base_url: "",
      Info: {
        clienti: [],
      },
      Filters: {
        IdClient: "",
        Numar: "",
        An: "",
        TipAuto: "-1",
        DataDeschiderii: "",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
      Interval: '',
      observatiiPrestabiliteDeviz: [],
    };
  },
  methods: {

    open_penalizare(row) {
      this.$refs.dlg_penalizare.open(row);
    },
    async preview(id) {
      this.$refs.preview_deviz.show(id)
    },
    async aprobaTrigger(id) {
      try {
        const response = await this.post(
          "service/devize/get_nr_roti",
          {
            idDeviz: id,
          }
        );

        let cantitate = 0;
        let observatii = null;

        if (response.cantitate) {
          cantitate = response.cantitate;
        }

        if (response.observatii) {
          observatii = response.observatii;
        }

        const response_programare = await this.post(
          "receptie/devize/get_programare_deviz",
          {
            idDeviz: id,
          }
        );

        let idProgramare = -1;

        if (response_programare && response_programare.IdProgramare) {
          idProgramare = response_programare.IdProgramare;
        }
        this.$refs.devize_de_aprobat.show_me(id, this.observatiiPrestabiliteDeviz, cantitate, observatii, idProgramare);

      } catch (error) {
        console.error(
          "A intervenit o problema in obtinerea starii rotilor!",
          error
        );
        this.$message({
          type: "error",
          message: "A intervenit o problema in obtinerea starii rotilor!",
        });
      }
    },

    async aproba(existaObservatii, idDeviz, observatie, observatiiPrestabiliteSelectate, destinatieAnvelope, produsMontajSenzori) {
      if (!existaObservatii) {
        try {
          const response = await this.post("receptie/devize/aproba", { idDeviz: idDeviz, observatii: null, destinatieAnvelope, produsMontajSenzori });
          if (!response.error) {
            this.$message.success('Devizul a fost aprobat cu succes fara observatii!');
          } else {
            this.$message.error(response.error);
          }
        } catch (error) {
          console.error(error);
          this.$message.error('A intervenit o problema in aprobarea devizului!');
        } finally {
          this.refresh_info();
        }
      } else {
        try {
          const obsJsonArr = []
          obsJsonArr.push({ observatie: observatie })
          obsJsonArr.push({ observatiiPreselectate: observatiiPrestabiliteSelectate })

          const response = await this.post("receptie/devize/aproba", { idDeviz: idDeviz, observatii: JSON.stringify(obsJsonArr), destinatieAnvelope, produsMontajSenzori });
          if (!response.error) {
            this.$message.success('Devizul a fost aprobat cu succes!');
          } else {
            this.$message.error(response.error);
          }
        } catch (error) {
          console.error(error);
          this.$message.error('A intervenit o problema in aprobarea devizului!');
        } finally {
          this.refresh_info();
        }
      }


    },

    async respinge(id) {
      this.showDialogRespingere = true;
      this.devizSelectat.Id = id;
      this.devizSelectat.MotivRespingere = '';
    },

    async get_info() {
      var response = await this.post("receptie/devize/get_info");
      this.Info.clienti = response.clienti;
      // if (this.Filters.IdClient.length > 0)
      //   this.Filters.IdClient = this.Info.clienti[0].Id;
      this.refresh_info();
      this.Interval = setInterval(() => {
        this.refresh_info();
      }, 5000);
    },

    async get_info_for_dialog() {
      try {
        this.observatiiPrestabiliteDeviz = [];
        const response = await this.post("receptie/devize/get_observatii_deviz")
        // console.log("response:",response);
        this.observatiiPrestabiliteDeviz = response.observatii;
      } catch (error) {
        console.error(error)
      }
    },

    async confirmaStergere() {
      this.showDialogMotivStergere = false;
      var response = await this.post('receptie/devize/sterge', {
        id: this.idDeSters,
        motiv: this.motivStergere
      });


      if (response.Success) {
        this.$message({ type: 'success', message: 'Devizul a fost sters' });
      } else {
        this.$message({ type: 'error', message: 'A aparut o eroare' });
      }
      this.refresh_info();
    },

    async sterge(id) {
      this.showDialogMotivStergere = true;
      this.idDeSters = id;

    },

    async refresh_info() {
      var response = await this.post("receptie/devize/get_devize_de_aprobat", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.DevizeInLucru = response.DevizeInLucru;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("devize");
    },
    reset() {
      this.Filters = {
        IdClient: "",
        Numar: "",
        An: "",
        TipAuto: "-1",
        DataDeschiderii: "",
      };
      this.refresh_info();
    },
    respinge_deviz: async function () {
      await this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          let res = await this.post("receptie/Devize/respinge_deviz", { deviz: this.devizSelectat });
          if (res.success) {
            this.showDialogRespingere = false;
            this.$message({ message: 'Devizul a fost respins!', type: 'success' });
          } else {
            this.$message({ message: 'Cererea nu a putut fi efectuata!', type: 'error' });
          }

          this.refresh_info();
        }
      });
    },

  },
  async mounted() {
    // if (!this.$has_right("Management")) {
    //   this.$router.push("/no-rights");
    //   return;
    // }
    this.base_url = settings.BASE_URL;
    this.get_info();
    await this.get_info_for_dialog();
  },
  beforeDestroy() {
    clearInterval(this.Interval);
  }
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 50%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
